import { removeKeyOrThrow } from './../lib/createValidatePropsMethod'

/**
 * Checks that the repository is a valid object and doesn't have invalid props.
 * Will throw if it does
 * @param {object} repository
 */
function validateError(obj){
  var keys = Object.keys(obj)

  if (! (obj instanceof Error))
    throw new Error(`Object is not an instance of 'Error'.`)

  //removeKeyOrThrow(keys, 'message', `Missing prop on error 'message'.`)

  removeKeyOrThrow(keys, 'code', `Missing prop on error 'code'.`)
  // Optional param
  removeKey(keys, 'uri')

  if (keys.length > 0)
    throw new Error(`Error object has invalid props '${keys.join(`', '`)}'.`)
}


/**
 * Add an error
 * @param {object} error Expects props 'description' and 'code'.
 */
export function addError(error){
  // Normalize the error into an object
  validateError(error)

  return {
    type: 'ERROR',
    // Make the error a plain object so that it is serializable
    // We enforce adding real errors though incase we want to change
    // this behaviour at a later time
    // Or we could stick a throw in here for debugging
    error: {
      message: error.message,
      code: error.code,
      uri: error.uri,
    },
  }
}

/**
 * Removes a values from an array if it exists
 * @param {Array<string>} arr
 * @param {string} prop
 */
function removeKey(arr, prop){
  var index = arr.indexOf(prop)
  if (index != -1)
    arr.splice(index, 1)
}


// WEBPACK FOOTER //
// ./src/store/errors/actions.js